import React, {Component} from 'react';

import { Button, Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material';

class NotFound extends Component {
	reload() {
		this.props.history.go(this.props.location.pathname);
	}

	render() {
		return (
			<Card className="card card-medium">
				<CardHeader title={ this.props.t.page_not_found } />
				<CardContent>
					<Typography component="span" variant="body">
						{ this.props.t.not_found_try_again }
					</Typography>
				</CardContent>
				<CardActions>
					<Button
						variant="contained"
						onClick={this.reload.bind(this)}
						color="primary"
					>
						{ this.props.t.not_found_reload }
					</Button>
				</CardActions>
			</Card>
		)
	}
}

export default NotFound;
